import DB_PATH from "../DB_PATH";
import firebase from "../firebase";
import {
  hasLegacyCommunityReelCreatorConfig,
  migrateLegacyCommunityReelCreatorConfig,
  stripLegacyCommunityReelCreatorConfig,
} from "./reelCreatorConfig";
import {
  hasLegacyCommunityMedia,
  migrateLegacyCommunityMedia,
  stripLegacyCommunityMedia,
} from "./communityMedia";

export default (storeId, setStore) => {
  if (!storeId) return;

  firebase
    .firestore()
    .collection(DB_PATH.COMMUNITY)
    .doc(storeId)
    .get()
    .then((doc) => {
      if (doc.exists) {
        const data = (doc.data() || {}) as Record<string, unknown>;
        if (hasLegacyCommunityReelCreatorConfig(data)) {
          void migrateLegacyCommunityReelCreatorConfig(doc.id, data);
        }
        if (hasLegacyCommunityMedia(data)) {
          void migrateLegacyCommunityMedia(doc.id, data);
        }
        setStore(stripLegacyCommunityMedia(stripLegacyCommunityReelCreatorConfig(data)));
      } else {
        setStore(null);
      }
    })
    .catch((error) => {
      console.error("Error getting store:", error);
      setStore(null);
    });
};
